// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2fb_G","bigColWidth":"Table_bigColWidth__1NQs4","biggerColWidth":"Table_biggerColWidth__1elzG","row":"Table_row__156M-","col":"Table_col__HxHPk"};